module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-group', [(_vm.isHide()) ? _c('span', [_vm._v("无权限查看此项配置")]) : [(!_vm.notData) ? _c('span', [(_vm.conf.__options__) ? _c('b-form-select', {
    attrs: {
      "options": _vm.conf.__options__,
      "disabled": _vm.isDisabled(),
      "required": _vm.conf.__required__
    },
    model: {
      value: (_vm.conf.__value__),
      callback: function($$v) {
        _vm.$set(_vm.conf, "__value__", $$v)
      },
      expression: "conf.__value__"
    }
  }) : (_vm.conf.__type__ === 'DATETIME') ? _c('el-date-picker', {
    attrs: {
      "readonly": _vm.isDisabled(),
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "type": "datetime",
      "placeholder": _vm.conf.__desc__,
      "required": _vm.conf.__required__
    },
    model: {
      value: (_vm.conf.__value__),
      callback: function($$v) {
        _vm.$set(_vm.conf, "__value__", $$v)
      },
      expression: "conf.__value__"
    }
  }) : _c('b-form-input', {
    attrs: {
      "type": _vm.type,
      "placeholder": '' + _vm.conf.__default__,
      "disabled": _vm.isDisabled(),
      "required": _vm.conf.__required__
    },
    model: {
      value: (_vm.conf.__value__),
      callback: function($$v) {
        _vm.$set(_vm.conf, "__value__", $$v)
      },
      expression: "conf.__value__"
    }
  }), _vm._v(" "), _c('b-form-text', [_vm._v(_vm._s(_vm.conf.__desc__))])], 1) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3ab1a6e8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conffield.vue
// module id = nS/0
// module chunks = 4